<template>
  <div class="questionnaire-voting">
    <div class="inner-content">
      <Alert></Alert>
      <Questionnaire :id="this.$route.params.id"></Questionnaire>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/Utils/Alert.vue'
import Questionnaire from '@/components/Voting/Questionnaire.vue'

export default {
  name: 'QuestionnaireDetail',
  components: { Alert, Questionnaire },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('clearAlert')
    this.$store.commit('clearTitle')
    this.$store.commit('setQuestionnaire', {})
    next()
  }
}
</script>
